<template>
  <div ref="scrollTarget"></div>
</template>

<script setup lang="ts">
  import { ref, onMounted, onBeforeUnmount } from 'vue';

  import { INTERSECTION_API_CONFIG } from '../config';

  const emit = defineEmits<{ onIntersect: [] }>();

  const scrollTarget = ref<HTMLDivElement>();

  const observer = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting) {
      emit('onIntersect');
    }
  }, INTERSECTION_API_CONFIG);

  onMounted(() => {
    if (scrollTarget.value) {
      observer.observe(scrollTarget.value);
    }
  });

  onBeforeUnmount(() => observer.disconnect());
</script>
